// extracted by mini-css-extract-plugin
module.exports = {"carousel_3d_slide":"Slide_carousel_3d_slide__rJJSp","carousel_3d_slide_current":"Slide_carousel_3d_slide_current__BQ4j0"};